"use strict";

// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var _slicedToArray = require("G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toBinary = toBinary;
exports.writeField = writeField;
var reflect_js_1 = require("./reflect/reflect.js");
var binary_encoding_js_1 = require("./wire/binary-encoding.js");
var descriptors_js_1 = require("./descriptors.js");
// bootstrap-inject google.protobuf.FeatureSet.FieldPresence.LEGACY_REQUIRED: const $name: FeatureSet_FieldPresence.$localName = $number;
var LEGACY_REQUIRED = 3;
// Default options for serializing binary data.
var writeDefaults = {
  writeUnknownFields: true
};
function makeWriteOptions(options) {
  return options ? Object.assign(Object.assign({}, writeDefaults), options) : writeDefaults;
}
function toBinary(schema, message, options) {
  return writeFields(new binary_encoding_js_1.BinaryWriter(), makeWriteOptions(options), (0, reflect_js_1.reflect)(schema, message)).finish();
}
function writeFields(writer, opts, msg) {
  var _a;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;
  try {
    for (var _iterator = msg.sortedFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var f = _step.value;
      if (!msg.isSet(f)) {
        if (f.presence == LEGACY_REQUIRED) {
          throw new Error("cannot encode ".concat(f, " to binary: required field not set"));
        }
        continue;
      }
      writeField(writer, opts, msg, f);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  if (opts.writeUnknownFields) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
      for (var _iterator2 = ((_a = msg.getUnknown()) !== null && _a !== void 0 ? _a : [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _step2$value = _step2.value,
          no = _step2$value.no,
          wireType = _step2$value.wireType,
          data = _step2$value.data;
        writer.tag(no, wireType).raw(data);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
  return writer;
}
/**
 * @private
 */
function writeField(writer, opts, msg, field) {
  var _a;
  switch (field.fieldKind) {
    case "scalar":
    case "enum":
      writeScalar(writer, msg.desc.typeName, field.name, (_a = field.scalar) !== null && _a !== void 0 ? _a : descriptors_js_1.ScalarType.INT32, field.number, msg.get(field));
      break;
    case "list":
      writeListField(writer, opts, field, msg.get(field));
      break;
    case "message":
      writeMessageField(writer, opts, field, msg.get(field));
      break;
    case "map":
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;
      try {
        for (var _iterator3 = msg.get(field)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _step3$value = _slicedToArray(_step3.value, 2),
            key = _step3$value[0],
            val = _step3$value[1];
          writeMapEntry(writer, opts, field, key, val);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
      break;
  }
}
function writeScalar(writer, msgName, fieldName, scalarType, fieldNo, value) {
  writeScalarValue(writer.tag(fieldNo, writeTypeOfScalar(scalarType)), msgName, fieldName, scalarType, value);
}
function writeMessageField(writer, opts, field, message) {
  if (field.delimitedEncoding) {
    writeFields(writer.tag(field.number, binary_encoding_js_1.WireType.StartGroup), opts, message).tag(field.number, binary_encoding_js_1.WireType.EndGroup);
  } else {
    writeFields(writer.tag(field.number, binary_encoding_js_1.WireType.LengthDelimited).fork(), opts, message).join();
  }
}
function writeListField(writer, opts, field, list) {
  var _a;
  if (field.listKind == "message") {
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;
    try {
      for (var _iterator4 = list[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var item = _step4.value;
        writeMessageField(writer, opts, field, item);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
    return;
  }
  var scalarType = (_a = field.scalar) !== null && _a !== void 0 ? _a : descriptors_js_1.ScalarType.INT32;
  if (field.packed) {
    if (!list.size) {
      return;
    }
    writer.tag(field.number, binary_encoding_js_1.WireType.LengthDelimited).fork();
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;
    try {
      for (var _iterator5 = list[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var _item = _step5.value;
        writeScalarValue(writer, field.parent.typeName, field.name, scalarType, _item);
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }
    writer.join();
    return;
  }
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;
  try {
    for (var _iterator6 = list[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var _item2 = _step6.value;
      writeScalar(writer, field.parent.typeName, field.name, scalarType, field.number, _item2);
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }
}
function writeMapEntry(writer, opts, field, key, value) {
  var _a;
  writer.tag(field.number, binary_encoding_js_1.WireType.LengthDelimited).fork();
  // write key, expecting key field number = 1
  writeScalar(writer, field.parent.typeName, field.name, field.mapKey, 1, key);
  // write value, expecting value field number = 2
  switch (field.mapKind) {
    case "scalar":
    case "enum":
      writeScalar(writer, field.parent.typeName, field.name, (_a = field.scalar) !== null && _a !== void 0 ? _a : descriptors_js_1.ScalarType.INT32, 2, value);
      break;
    case "message":
      writeFields(writer.tag(2, binary_encoding_js_1.WireType.LengthDelimited).fork(), opts, value).join();
      break;
  }
  writer.join();
}
function writeScalarValue(writer, msgName, fieldName, type, value) {
  try {
    switch (type) {
      case descriptors_js_1.ScalarType.STRING:
        writer.string(value);
        break;
      case descriptors_js_1.ScalarType.BOOL:
        writer.bool(value);
        break;
      case descriptors_js_1.ScalarType.DOUBLE:
        writer.double(value);
        break;
      case descriptors_js_1.ScalarType.FLOAT:
        writer.float(value);
        break;
      case descriptors_js_1.ScalarType.INT32:
        writer.int32(value);
        break;
      case descriptors_js_1.ScalarType.INT64:
        writer.int64(value);
        break;
      case descriptors_js_1.ScalarType.UINT64:
        writer.uint64(value);
        break;
      case descriptors_js_1.ScalarType.FIXED64:
        writer.fixed64(value);
        break;
      case descriptors_js_1.ScalarType.BYTES:
        writer.bytes(value);
        break;
      case descriptors_js_1.ScalarType.FIXED32:
        writer.fixed32(value);
        break;
      case descriptors_js_1.ScalarType.SFIXED32:
        writer.sfixed32(value);
        break;
      case descriptors_js_1.ScalarType.SFIXED64:
        writer.sfixed64(value);
        break;
      case descriptors_js_1.ScalarType.SINT64:
        writer.sint64(value);
        break;
      case descriptors_js_1.ScalarType.UINT32:
        writer.uint32(value);
        break;
      case descriptors_js_1.ScalarType.SINT32:
        writer.sint32(value);
        break;
    }
  } catch (e) {
    if (e instanceof Error) {
      throw new Error("cannot encode field ".concat(msgName, ".").concat(fieldName, " to binary: ").concat(e.message));
    }
    throw e;
  }
}
function writeTypeOfScalar(type) {
  switch (type) {
    case descriptors_js_1.ScalarType.BYTES:
    case descriptors_js_1.ScalarType.STRING:
      return binary_encoding_js_1.WireType.LengthDelimited;
    case descriptors_js_1.ScalarType.DOUBLE:
    case descriptors_js_1.ScalarType.FIXED64:
    case descriptors_js_1.ScalarType.SFIXED64:
      return binary_encoding_js_1.WireType.Bit64;
    case descriptors_js_1.ScalarType.FIXED32:
    case descriptors_js_1.ScalarType.SFIXED32:
    case descriptors_js_1.ScalarType.FLOAT:
      return binary_encoding_js_1.WireType.Bit32;
    default:
      return binary_encoding_js_1.WireType.Varint;
  }
}